<style lang="scss" scoped>
.custom-label {
    @apply cursor-pointer;
    &:hover {
        .checkbox {
            @apply border-gray;
        }
    }
    .checkbox {
        height: 16px;
        width: 16px;
        border-radius: 3px;
        @apply bg-white mr-8 border border-gray flex justify-center items-center transition-colors;
        .icon {
            height: 10px;
            width: 10px;
        }

        &.checked {
            @apply bg-green border-green;
        }
    }
    .label {
        @apply text-dark font-medium text-small block;

        a {
            @apply text-green;
        }
    }
}
</style>

<template>
    <ValidationProvider ref="provider" :name="name" :rules="rules" :bails="false" v-slot="{ classes }" tag="div">
        <label class="custom-label flex items-center w-full" @click="$emit('click')">
            <div class="checkbox" :class="{ checked }">
                <input type="checkbox" class="hidden" ref="input" v-model="checked" @change="onChange" :value="onValue" :class="classes" :id="`id_${name}`" />
                <svg class="icon text-white pointer-events-none" :class="{ hidden: !checked }" viewBox="0 0 172 172">
                    <g fill="none" stroke-width="none" stroke-miterlimit="10" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode:normal">
                        <path d="M0 172V0h172v172z" />
                        <path d="M145.433 37.933L64.5 118.8658 33.7337 88.0996l-10.134 10.1341L64.5 139.1341l91.067-91.067z" fill="currentColor" stroke-width="1" />
                    </g>
                </svg>
            </div>
            <span class="label select-none" v-if="hasLabelSlot || labelText" :for="`id_${name}`" :class="[classes]">
                <template v-if="hasLabelSlot">
                    <slot name="label"></slot>
                </template>
                <span v-else v-html="labelText"> </span>
            </span>
        </label>
    </ValidationProvider>
</template>

<script>
import HasInput from "@/mixins/components/has-input";
import { ValidationProvider } from "vee-validate";

export default {
    name: "Forms.Elements.ElCheckbox",

    mixins: [HasInput],

    components: { ValidationProvider },

    props: {
        onValue: {
            default: true,
            type: Boolean
        },

        value: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            // checked: false
        };
    },

    methods: {
        onChange() {
            this.$emit("input", this.localValue);
        }
    },

    computed: {
        hasLabelSlot() {
            return !!this.$slots.label;
        },
        checked: {
            // getter
            get: function() {
                return this.value;
            },
            // setter
            set: function(val) {
                this.localValue = val;
            }
        }
    }
};
</script>
